import type { CourseListParams } from '@/types';

// Query keys compartidas por los sub-módulos de course-builder (ENG-LOC-01).
export const KEYS = {
  all: ['course-builder'] as const,
  list: (params?: CourseListParams) => [...KEYS.all, 'list', params] as const,
  detail: (id: number) => [...KEYS.all, 'detail', id] as const,
  quiz: (quizId: number) => ['quizzes', 'detail', quizId] as const,
  instructorCandidates: ['instructor-candidates'] as const,
  positions: (courseId: number) => [...KEYS.all, 'positions', courseId] as const,
  recurrence: (courseId: number) => [...KEYS.all, 'recurrence', courseId] as const,
};
